<!-- 影音展播区块 -->
<template>
    <div class="moviesblock-container" ref="mbContainer" v-loading="dataloading">
      <div class="main-box page-content-box">
        <BlockTitle
          title="影音展播"
          channelAlias="yingyin"></BlockTitle>
        <!--
        <Slick ref="slick" :options="slickOptions">
            <div v-for="(item) in moviesList" :key="item.id">
              <el-image
                  style="width:360px; height: 240px;"
                  :src="require('@/assets/img/'+item.image)"
                  fit="contain"></el-image>
            </div>
        </Slick>
        -->
        <template v-if="dataloading == false">
          <template v-if="blockItems.length > 0">
            <swiper class="movie-swiper" ref="swiper" :options="swiperOption">
              <swiper-slide
                class="movie-slide"
                :style="{'width': videoWidth+'px', 'height': videoHeight+'px'}"
                v-for="item in blockItems"
                :key="item.id">
                <MediaItem
                  style="width: 100%;height: 100%;"
                  :coverImg="item.image"
                  :video="item.video"
                  :audio="item.audio"
                  :titleShown="false"
                  :articleId="item.articleId"></MediaItem>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
            <!--
            <div v-else class="movie-list">
              <el-row v-if="blockItems.length > 0">
                <el-col :span="12" style="padding-right:4px;">
                  <MediaItem v-if="blockItems.length > 0"
                    style="width: 100%;height: 100%;"
                    :coverImg="blockItems[0].image"
                    :video="blockItems[0].video"
                    :titleShown="false"
                    :articleId="blockItems[0].articleId"
                    :key="blockItems[0].id"></MediaItem>
                </el-col>
                <el-col :span="12" style="padding-left:4px;">
                  <MediaItem v-if="blockItems.length > 1"
                    style="width: 100%;height: 100%;"
                    :coverImg="blockItems[1].image"
                    :video="blockItems[1].video"
                    :titleShown="false"
                    :articleId="blockItems[1].articleId"
                    :key="blockItems[1].id"></MediaItem>
                </el-col>
              </el-row>
              <el-row v-if="blockItems.length > 2" style="margin-top:10px;">
                <el-col :span="12" style="padding-right:4px;">
                  <MediaItem v-if="blockItems.length > 2"
                    style="width: 100%;height: 100%;"
                    :coverImg="blockItems[2].image"
                    :video="blockItems[2].video"
                    :titleShown="false"
                    :articleId="blockItems[2].articleId"
                    :key="blockItems[2].id"></MediaItem>
                </el-col>
                <el-col :span="12" style="padding-left:4px;">
                  <MediaItem v-if="blockItems.length > 3"
                    style="width: 100%;height: 100%;"
                    :coverImg="blockItems[3].image"
                    :video="blockItems[3].video"
                    :titleShown="false"
                    :articleId="blockItems[3].articleId"
                    :key="blockItems[3].id"></MediaItem>
                </el-col>
              </el-row>
            </div>
            -->
          </template>
          <div v-else>
            <el-empty :image-size="50"></el-empty>
          </div>
        </template>
      </div>
    </div>
</template>

<script>

  import BlockTitle from "@/components/blocks/blocktitle";
  import MediaItem from "@/components/basic/mediaitem";
  //import Slick from "vue-slick";
  import "swiper/dist/css/swiper.css";
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import { getBlockItemList } from "@/api/content";
  import * as channelConfig from "@/config/channels";

  export default{
      components: {BlockTitle, swiper, swiperSlide, MediaItem},
      props:{},
      data(){
          return {
            swiperMode: true,
            swiperOption: {
              slidesPerView: 'auto',
              spaceBetween: 10,
              direction: 'horizontal',
              centerInsufficientSlides: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              }
            },

            blockAlias: channelConfig.blockAlias.BLOCK_ALIAS_YINGYINZHANBO,
            blockItems: [],
            videoWidth: 360+20,
            videoHeight: 240,

            dataloading: true,
          };
      },
      methods:{
        getDataList(){
          this.dataloading = true;
          getBlockItemList(0, this.blockAlias, 10).then(result => {
            this.dataloading = false;
              if(result.code == 0){
                  if(result.data != null){
                    this.blockItems = result.data;
                  }
              }else{
                  this.blockItems = [];
              }

              //console.log(result.data.list);
          }).catch((err)=>{
            this.dataloading = false;
          });
        },

        onResize(){
          //let screenW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          let screenW = document.documentElement.clientWidth;
          if(screenW <= 760){
            this.videoWidth = screenW * 0.5 - 20;
            this.videoHeight = this.videoWidth * 24/36;
          }else{
            this.videoWidth = 380;
            this.videoHeight = 240;
          }
          //let wContainer = this.$refs.mbContainer.clientWidth;
          //if(wContainer <= 600){
          //  this.swiperMode = false;
          //}else{
          //  this.swiperMode = true;
          //}
        }
      },
      created(){
        window.addEventListener('resize', this.onResize);
        this.getDataList();        
      },
      destroyed(){
        window.removeEventListener('resize', this.onResize);
      },
      mounted(){
        this.$nextTick(()=>{
            this.onResize();
        });
      },
    };
</script>
<style scoped>
 .moviesblock-container{
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: center;
    margin: 60px 0px;
 }
 .main-box{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: center;
    /*gap: 40px;*/
 }

 .movie-swiper{
    width: 100%;
    margin-top: 40px;
 }
 .movie-slide{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction:column;
    align-items: center;
    justify-content: center;

    padding: 0 10px;
 }
 .movie-list{
  width: 100%;
 }
 .el-row{
  width: 100%;
  height: 120px;
 }
 .el-col{
  width: 50%;
  height: 100%;
 }

 @media screen and (max-width: 1000px) {
  .moviesblock-container{
    margin: 24px 0;    
  }
  /*
  .main-box{
    gap: 24px;
  }
  */
  .movie-swiper{    
    margin-top: 24px;
 }
}  
 @media screen and (max-width: 760px){
  .movie-slide{
    padding: 0px;
  }
  .swiper-button-next, .swiper-button-prev{
    display: none;
  }
 }
</style>



// WEBPACK FOOTER //
// src/components/blocks/moviesblock/index.vue